import { Reducer } from "@ctra/utils";

import { AskIdaState } from "./typings";
import { cleanup } from "../../utils/reducer";
import types from "./types";
import { FetchQnAListFulfilledPayload, FetchQnAsFulfilledPayload } from "./actions";

export const initialState: AskIdaState = { entities: {}, collections: {} };

/**
 * Questions and answers reducer
 * @param state
 * @param action
 */
const reducer: Reducer<AskIdaState> = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.FETCH_ASK_IDA_TRACKER.fulfilled: {
      const {
        entities: { QnA }
      } = payload as FetchQnAsFulfilledPayload;

      return {
        ...state,
        entities: {
          ...state.entities,
          ...QnA
        }
      };
    }

    case types.FETCH_ASK_IDA_TRACKER_LIST.fulfilled: {
      const {
        hash,
        entities: { QnA },
        result
      } = payload as FetchQnAListFulfilledPayload;

      return {
        ...state,
        entities: {
          ...state.entities,
          ...QnA
        },
        collections: {
          ...state.collections,
          [hash]: result
        }
      };
    }
  }

  return state;
};

export default cleanup<AskIdaState>(initialState)(reducer);
